var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellWithAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.25 18.5C21.2457 19.2047 20.6914 19.875 19.8707 19.875H3.37846C2.55861 19.875 2.00389 19.2047 2.00002 18.5C1.99814 18.1529 2.13073 17.8186 2.36998 17.5671C3.20014 16.6751 4.75346 15.3328 4.75346 10.9375C4.75346 7.59883 7.09439 4.92617 10.2509 4.27047V3.375C10.2509 3.01033 10.3957 2.66059 10.6536 2.40273C10.9115 2.14487 11.2612 2 11.6259 2C11.9906 2 12.3403 2.14487 12.5982 2.40273C12.856 2.66059 13.0009 3.01033 13.0009 3.375V4.27047C16.1548 4.92617 18.4957 7.59883 18.4957 10.9375C18.4957 15.3332 20.049 16.6751 20.8792 17.5671C21.1187 17.8185 21.2516 18.1528 21.25 18.5Z",
    fill: "#335C75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.875 21.25H14.375C14.375 21.9793 14.0853 22.6788 13.5695 23.1945C13.0538 23.7103 12.3543 24 11.625 24C10.8957 24 10.1962 23.7103 9.68046 23.1945C9.16473 22.6788 8.875 21.9793 8.875 21.25Z",
    fill: "#335C75"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 4.5,
    r: 3.75,
    fill: "#DA515E",
    stroke: "#F5F7F8",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellWithAlert);
export default __webpack_public_path__ + "static/media/BellWithAlert.11b807367f4c8c113cfd2112c42dcb1b.svg";
export { ForwardRef as ReactComponent };